export { default as Cod, Captcha, Otp } from "./Cod";
export {
  default as CreditCard,
  CreditCardHolderName,
  CreditCardNumber,
  Cvv,
  ExpMonth,
  ExpYear,
} from "./CreditCard";
export { default as NetBanking } from "./NetBanking";
export { default as UPI } from "./UPI";
export { default as Preload } from "./Preload";
export { default as E_Wallet } from "./E_Wallet";
export { default as Paytm } from "./Paytm";
export { default as PaymentCard } from "./PaymentCard";

export default {
  credit: "test",
  "net banking": "netbanking",
};



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/index.js